import PropTypes from 'prop-types';
import React from 'react';
import './style.scss';

const ChoiceField = ({ input, id, label, styleLabel = '', type }) => (
    <label
        className={
            `choicefield
            ${styleLabel}
            ${input.checked ? 'choicefield--active' : null}`
        }
        htmlFor={id}
    >
        {label}
        <input {...input} id={id} type={type} />
    </label>
);

ChoiceField.propTypes = {
    id: PropTypes.string.isRequired,
    input: PropTypes.shape({
        checked: PropTypes.bool,
        onChange: PropTypes.func,
        value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
    }),
    label: PropTypes.string,
    styleLabel: PropTypes.string,
    type: PropTypes.string.isRequired,
};

export default ChoiceField;
